import { Fab, FabProps } from "@mui/material";
import styles from "./styles.module.css";
import classNames from "classnames";

interface Props extends FabProps {
  icon: React.ReactNode;
  className?: string;
}

export const AppFloatButton = ({ icon, className, ...rest }: Props) => {
  return (
    <Fab
      className={classNames(styles["floating-action-btn"], className)}
      {...rest}
    >
      {icon}
    </Fab>
  );
};
